import { Box, Alert, AlertIcon, AlertDescription } from '@chakra-ui/react';
export default function ErrorMessage({status = 'error', message }) {
    return (
        <Box my={4}>
            <Alert status={status} borderRadius={4}>
                <AlertIcon />
                <AlertDescription> {message}</AlertDescription>
            </Alert>
        </Box>
    )
}